import variable from './variable';
import help from './help';
import api from './api'

export default {
    state: {
        loading: {},
        btnRights: {},
        alertInfo: {
            show: false,
            loading: false,
        },
        userInfo: {},
        pageType: variable.pageType.NORMAL,
    },
    mutations: {
        // 设置页面跳转
        setPage(state, page) {
            state.pageType = page
        },

        setBtnRights(state, data) {
            state.btnRights = data
        },


        alert(state, option = {}) {
            if (typeof option === 'string') {
                option = {
                    content: option
                }
            }
            let defaultOption = {
                show: true,
                title: '提示',
                content: '请先选择有效记录，再执行该操作。',
                loading: false,
                hideCancel: true,
                callback: () => {
                    state.alertInfo.loading = false
                    state.alertInfo.show = false
                },
            }
            state.alertInfo = help.joinObj(defaultOption, option)
        },
        confirm(state, option = {}) {
            let defaultOption = {
                show: true,
                title: '提示',
                content: '',
                loading: false,
                callback: () => {
                },
            }
            state.alertInfo = help.joinObj(defaultOption, option)
        },
    },
    actions: {
         setUser(context) {
            api.get('sys/login/getCurrUser',{})
                .then(res => {
                    context.state.userInfo = res
                })
        },
    },
}